'use strict';

var _classCallCheck = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Modal = require('shared/components/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _modalWrapper = require('shared/hoc/modalWrapper');

var _modalWrapper2 = _interopRequireDefault(_modalWrapper);

var _ContactUsForm = require('./ContactUsForm');

var _ContactUsForm2 = _interopRequireDefault(_ContactUsForm);

var _styled = require('./styled');

var _styled2 = _interopRequireDefault(_styled);

var _buttons = require('shared/styled/buttons');

var _buttons2 = _interopRequireDefault(_buttons);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ContanctUs =
/*#__PURE__*/
function (_react$Component) {
  _inherits(ContanctUs, _react$Component);

  function ContanctUs() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ContanctUs);

    var _temp;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ContanctUs)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.ContactUsForm = _react2.default.createRef(), _this.onFormSubmit = function () {
      _this.ContactUsForm.current.props.onSubmit();
    }, _this.renderModalFooter = function () {
      return _react2.default.createElement(_styled2.default.ModalFooter, null, _react2.default.createElement(_styled2.default.MandatoryInfo, null, _react2.default.createElement(_styled2.default.MandatorySign, null, '*'), ' Mandatory fields'), _react2.default.createElement('span', null, _react2.default.createElement(_buttons2.default.ThemedButton, {
        onClick: _this.props.close
      }, 'Cancel'), _react2.default.createElement(_buttons2.default.ThemedButton, {
        onClick: _this.onFormSubmit,
        type: 'primary'
      }, 'Send')));
    }, _temp));
  }

  _createClass(ContanctUs, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          initialValues = _this$props.initialValues,
          close = _this$props.close;
      return _react2.default.createElement(_Modal2.default, {
        title: 'Write us a message',
        config: {
          isOpen: true,
          onRequestClose: this.props.close,
          className: 'react-modal-container_w520'
        },
        footer: this.renderModalFooter(),
        shouldCloseOnOverlayClick: false
      }, _react2.default.createElement(_ContactUsForm2.default, {
        modalClose: close,
        initialValues: initialValues,
        formRef: this.ContactUsForm
      }));
    }
  }]);

  return ContanctUs;
}(_react.Component);

exports.default = (0, _modalWrapper2.default)('ContanctUsModal')(ContanctUs);